<template>
  <v-list-item @click="$emit('click', item)" color="primary">
    <v-list-item-content>
      <v-list-item-title>
        {{ item.rua }}, {{ item.numero || "S/N" }}
      </v-list-item-title>
      <v-list-item-subtitle>
        {{ item.bairro || "S/ Bairro" }}
      </v-list-item-subtitle>
      <v-list-item-subtitle>
        {{ item.cidade }} - {{ item.uf }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-btn @click.stop="$emit('click:delete', item)" icon>
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  props: {
    item: Object
  }
};
</script>
